import React from 'react';
import { XIcon } from 'lucide-react';
interface PrivacyPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PrivacyPolicyModal({
  isOpen,
  onClose
}: PrivacyPolicyModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4" data-id="element-169">
      <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto" data-id="element-170">
        <div className="sticky top-0 bg-gray-900 border-b border-gray-700 p-6 flex justify-between items-center" data-id="element-171">
          <h2 className="text-2xl font-bold text-white" data-id="element-172">
            Política de Privacidad
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors" aria-label="Close" data-id="element-173">
            <XIcon className="h-6 w-6" data-id="element-174" />
          </button>
        </div>
        <div className="p-6 text-gray-300 space-y-4" data-id="element-175">
          <section data-id="element-176">
            <h3 className="text-xl font-semibold text-white mb-2" data-id="element-177">
              1. Información que Recopilamos
            </h3>
            <p data-id="element-178">
              Recopilamos información personal que usted nos proporciona
              directamente, como su nombre, dirección de correo electrónico y
              otra información de contacto cuando se registra para nuestros
              servicios o eventos.
            </p>
          </section>
          <section data-id="element-179">
            <h3 className="text-xl font-semibold text-white mb-2" data-id="element-180">
              2. Uso de la Información
            </h3>
            <p data-id="element-181">
              Utilizamos la información recopilada para proporcionarle acceso a
              nuestros servicios, enviarle comunicaciones relacionadas con
              eventos, y mejorar nuestros servicios.
            </p>
          </section>
          <section data-id="element-182">
            <h3 className="text-xl font-semibold text-white mb-2" data-id="element-183">
              3. Compartir Información
            </h3>
            <p data-id="element-184">
              No vendemos, alquilamos ni compartimos su información personal con
              terceros, excepto cuando sea necesario para proporcionar nuestros
              servicios o cuando lo exija la ley.
            </p>
          </section>
          <section data-id="element-185">
            <h3 className="text-xl font-semibold text-white mb-2" data-id="element-186">
              4. Seguridad
            </h3>
            <p data-id="element-187">
              Implementamos medidas de seguridad apropiadas para proteger su
              información personal contra acceso no autorizado, alteración o
              destrucción.
            </p>
          </section>
          <section data-id="element-188">
            <h3 className="text-xl font-semibold text-white mb-2" data-id="element-189">
              5. Sus Derechos
            </h3>
            <p data-id="element-190">
              Usted tiene derecho a acceder, corregir o eliminar su información
              personal. Para ejercer estos derechos, contáctenos en
              support@truemarketer.com.
            </p>
          </section>
          <section data-id="element-191">
            <h3 className="text-xl font-semibold text-white mb-2" data-id="element-192">
              6. Contacto
            </h3>
            <p data-id="element-193">
              Si tiene preguntas sobre esta política de privacidad, contáctenos
              en{' '}
              <a href="mailto:support@truemarketer.com" className="text-red-500 hover:text-red-400" data-id="element-194">
                support@truemarketer.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>;
}